import { getAuth, onAuthStateChanged } from "firebase/auth";
import React, { useEffect } from "react";
import { Provider as ReduxProvider, useDispatch, useSelector } from 'react-redux';
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import './App.css';
import './firebase';
import Footer from "./components/footer";
import MsgToast from "./components/msg-toast";
import Sidebar from "./components/sidebar";
import ColoringScreen from './screens/coloring-screen';
import MobileColoringScreen from './screens/mobile-coloring-screen';
import HomeScreen from './screens/home-screen';
import PrivacyPolicyScreen from "./screens/privacy-policy-screen";
import TermsScreen from "./screens/terms-screen";
import ProfileScreen from "./screens/profile-screen";
import SignInScreen from "./screens/sign-in-screen";
import { resetCrtUser, setCrtUser, store } from "./store";
import AskToSignInModal from "./components/ask-to-sign-in-modal";
import PageTracking from "./components/page-tracking";
import NotFoundScreen from "./screens/not-found-screen";

function RouterApp() {
  const dispatch = useDispatch()
  const auth = getAuth()
  const crtUser = useSelector(state => state.crtUser)

  useEffect(() => {
    onAuthStateChanged(auth, user => {
      if (user) {
        dispatch(setCrtUser(user.toJSON()))
      } else
        dispatch(resetCrtUser())
    })
  }, [])

  function elemOrNav(elm, isPrivate, isSignInScreen) {
    const loggedIn = crtUser.uid !== null
    const shouldNavigate = (!loggedIn && isPrivate) || (loggedIn && isSignInScreen)

    if (shouldNavigate) {
      return <Navigate to={isSignInScreen ? '/' : '/sign-in'} replace />
    }

    return elm
  }

  return (
    <BrowserRouter>
      <PageTracking />
      <MsgToast />
      <Sidebar />
      <Footer />
      <AskToSignInModal />
      <Routes>
        <Route path="/" element={elemOrNav(<HomeScreen />, false, false)} />
        <Route path="/coloring/:drawingId" element={elemOrNav(<ColoringScreen />, false, false)} />
        <Route path="/mobile-coloring/:drawingId" element={elemOrNav(<MobileColoringScreen />, false, false)} />
        <Route path="/sign-in" element={elemOrNav(<SignInScreen />, false, true)} />
        <Route path="/profile" element={elemOrNav(<ProfileScreen />, true, false)} />
        <Route path="/privacy-policy" element={elemOrNav(<PrivacyPolicyScreen />, false, false)} />
        <Route path="/terms-of-service" element={elemOrNav(<TermsScreen />, false, false)} />
        <Route path="*" element={<NotFoundScreen />} />
      </Routes>
    </BrowserRouter>
  );
}

function App() {
  return (
    <ReduxProvider store={store}>
      <RouterApp />
    </ReduxProvider>
  );
}

export default App
